<template>
    <fade-up-animation :element="() => $refs.section">
        <div class="retailer-logos-grid-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <retailer-logos
                        :retailers="retailers"
                    />
                </mobile-gutter>
            </b-container>
        </div>
    </fade-up-animation>
</template>

<script>
    import RetailerLogos from '../../molecules/RetailerLogos/RetailerLogos';

    export default {
        name: 'retailer-logos-grid-section',

        components: { RetailerLogos },

        props: {
            retailers: {
                type: Array,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .retailer-logos-grid-section {
        padding: 30px 0;
        text-align: center;
    }

    .retailer-logos {
        max-width: 720px;
        margin: 0 auto;
    }
</style>
